<div class="d-flex-between" (click)="onShowModal()">
    <div class="font-h5">
        {{title}}
    </div>
    <div *ngIf="isDemoMode" class="btn-tag-primary-light text-body" style="border: 2px solid #01E68D !important;"
        (click)="onOpenModal()">
        Modo DEMO Activado
    </div>
</div>


<ng-template #testModal let-modal>
    <div class="modal-body">
        <div class="m-t-16 text-center">
            <div class="container" style="width: 320px;">
                <img class="logo-invitation" src="assets/images/descarga-app-invitado.png" width="90%" />
                <br>
                <div class="m-t-16 title">¡Cambiar a modo DEMO!</div>

                <!-- Switch -->
                <div class="m-t-20 d-flex-center-center" (click)="onToggleDemoMode()">
                    <ui-switch [(ngModel)]="isDemoMode" (change)="onToggleDemoMode()" color="#28a745"
                        switchOffColor="#ccc"></ui-switch>
                    <span class="label-text" style="margin-left: 8px;">Modo demo</span>
                </div>

                <div *ngIf="isDemoMode" class="m-t-16">
                    <div class="font-bold">
                        Modo DEMO Activado.
                    </div>
                    <div class="font-c2">
                        Estás trabajando con datos de prueba.
                    </div>
                </div>
                <div *ngIf="!isDemoMode" class="m-t-16">
                    <div class="font-bold">
                        Modo DEMO Desactivado.
                    </div>
                    <div class="font-c2">
                        Estás trabajando con datos reales.
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center m-t-24">
            <div class="font-14 text-muted cursor-pointer" (click)="modal.dismiss()">Cerrar</div>
        </div>
    </div>
</ng-template>